import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { WebServiceService } from '../../shared/services/web-service.service';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';

@Component({
  selector: 'app-dynamic-vendor-invoice-pie-chart',
  templateUrl: './dynamic-vendor-invoice-pie-chart.component.html',
  styleUrls: ['./dynamic-vendor-invoice-pie-chart.component.scss']
})
export class DynamicVendorInvoicePieChartComponent implements OnInit {

// @Input() dataTosend: any;
  // Pie
  @Input() labels: string[];
  @Input() data: number[];
  @Input() pieChartType?: string = 'pie';
  @Input() colors?: any = ['#FF8C00','#00FA9A','#32CD32','#FF0000','#0000CD','#FFFF00','#4CAF50','#2196F3','#795548']
  @Input() pieChartLegend?:boolean=true;
  @Input() title:any;
  ChartLegend:boolean=true;

  pieChartColors: any;
  public pieChartPlugins = [pluginDataLabels];

  public options: any = {
    responsive: true,
    maintainAspectRatio: true,
    legend: {
      position: 'right',
      orient: 'vertical',
    },
    plugins: {
      labels: {
        render: 'percentage',
        // fontColor: ['green', 'white', 'red'],
        precision: 2,
        arc: true,

      },
      datalabels: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    }
  }

  constructor(private router: Router,public webService: WebServiceService,) { }

  ngOnInit() {
    this.pieChartColors = [{ backgroundColor: this.colors }];
  }

  public chartClicked(e: any): void {

  }

  chartHovered(e: any): void {
  }

 

}



// WEBPACK FOOTER //
// /codebuild/output/src825240186/src/src/app/common/dynamic-vendor-invoice-pie-chart/dynamic-vendor-invoice-pie-chart.component.ts